import { useState, useRef } from "react";
import { Upload, X } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Uploader({ value = [], onChange, multiple = true, label = "Ajouter des photos", hint }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef();
  const list = Array.isArray(value) ? value : value ? [value] : [];

  const handle = async (files) => {
    setBusy(true);
    const urls = [];
    for (const file of Array.from(files)) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      } catch { toast.error("Échec de l'upload"); }
    }
    onChange(multiple ? [...list, ...urls] : urls[0] || "");
    setBusy(false);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-3">
        {list.map((u, i) => (
          <div key={i} className="relative w-20 h-24 bg-neutral-100 overflow-hidden group">
            <img src={u} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(multiple ? list.filter((_, idx) => idx !== i) : "")} className="absolute top-1 right-1 bg-white/90 w-5 h-5 flex items-center justify-center"><X size={11} /></button>
          </div>
        ))}
        <button type="button" onClick={() => ref.current.click()} disabled={busy} className="w-20 h-24 border border-dashed border-neutral-300 flex flex-col items-center justify-center gap-1 text-neutral-400 hover:border-neutral-900" data-testid="uploader-button">
          <Upload size={16} />
          <span className="text-[0.55rem]">{busy ? "…" : "Parcourir"}</span>
        </button>
      </div>
      {(hint || label) && <p className="text-xs text-neutral-400 mt-2">{hint || label}</p>}
      <input ref={ref} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={(e) => e.target.files.length && handle(e.target.files)} />
    </div>
  );
}
